// Display helpers for the Pulse Price Changes page.

export const PULSE_TABS = [
  { id: 'all', label: 'All Pulses' },
  { id: 'tur', label: 'Tur' },
  { id: 'urad', label: 'Urad' },
  { id: 'moong', label: 'Moong' },
  { id: 'chana', label: 'Chana' },
  { id: 'masoor', label: 'Masoor' },
];

const SHORT = { tur: 'Tur', urad: 'Urad', moong: 'Moong', chana: 'Chana', masoor: 'Masoor' };

export const formatInr = (value) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? '—'
    : `₹${Math.round(Number(value)).toLocaleString('en-IN')}`;

export const formatPct = (value) =>
  value === null || value === undefined ? '—' : `${value > 0 ? '+' : ''}${Number(value).toFixed(1)}%`;

// 'up' | 'down' | 'flat' — tiny moves under 0.05% count as flat.
export const priceTone = (value) =>
  value === null || value === undefined || Math.abs(value) < 0.05 ? 'flat' : value > 0 ? 'up' : 'down';

export const pulseName = (row) =>
  `${SHORT[row.pulse] || row.commodity}${/dal/i.test(row.commodity || '') ? ' Dal' : ''}`;

export const filterPulseRows = (rows = [], { pulse = 'all', district = 'all', query = '' } = {}) => {
  const q = query.trim().toLowerCase();
  return rows.filter(
    (r) =>
      (pulse === 'all' || r.pulse === pulse) &&
      (district === 'all' || r.district === district) &&
      (!q || `${r.market} ${r.district} ${r.state} ${pulseName(r)}`.toLowerCase().includes(q))
  );
};

// Missing values always sort last, whichever direction.
export const sortPulseRows = (rows = [], { key = 'changePct', dir = 'desc' } = {}) =>
  [...rows].sort((a, b) => {
    const x = a[key];
    const y = b[key];
    if (x === null || x === undefined) return y === null || y === undefined ? 0 : 1;
    if (y === null || y === undefined) return -1;
    const order = typeof x === 'string' ? x.localeCompare(y) : x - y;
    return dir === 'asc' ? order : -order;
  });

export const pulseMovers = (rows = []) => {
  const changed = rows.filter((r) => r.changePct !== null && r.changePct !== undefined);
  const gainer = changed.reduce((best, r) => (r.changePct > 0 && (!best || r.changePct > best.changePct) ? r : best), null);
  const loser = changed.reduce((best, r) => (r.changePct < 0 && (!best || r.changePct < best.changePct) ? r : best), null);
  return {
    rising: rows.filter((r) => r.change > 0).length,
    falling: rows.filter((r) => r.change < 0).length,
    gainer,
    loser,
  };
};

export const timeAgo = (iso, now = Date.now()) => {
  if (!iso) return '';
  const minutes = Math.round((now - new Date(iso).getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  return `${Math.round(minutes / 60)} h ago`;
};
